import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {deleteUserMerchant,wechatMerchants,wechatMerchant,wechatCusPay,alipayMerchants,alipayMerchant,userMerchants,saveMechantUser,saveUserPaySwitch,saveUserWechatMerchant,updateUserWechatMerchant,saveUserAlipayMerchant,updateUserAlipayMerchant} = api



/**
 * 查找
 */
export async function delUserMerchant(params) {
    return request({url: deleteUserMerchant, method: 'post', data: params,})
}
export async function addUserAlipayMerchant(params) {
    return request({url: saveUserAlipayMerchant, method: 'post', data: params,})
}
export async function modifyUserAlipayMerchant(params) {
    return request({url: updateUserAlipayMerchant, method: 'post', data: params,})
}

export async function addUserWechartMerchant(params) {
    return request({url: saveUserWechatMerchant, method: 'post', data: params,})
}
export async function modifyUserWechartMerchant(params) {
    return request({url: updateUserWechatMerchant, method: 'post', data: params,})
}
export async function setUserPaySwitch(params) {
    return request({url: saveUserPaySwitch, method: 'post', data: params,})
}
export async function addMechantUser(params) {
    return request({url: saveMechantUser, method: 'post', data: params,})
}
export async function findUserMerchants(params) {
    return request({url: userMerchants, method: 'get', data: params,})
}
export async function findWechatMerchants(params) {
    return request({url: wechatMerchants, method: 'get', data: params,})
}
export async function createWechatMerchants(params) {
    return request({url: wechatMerchants, method: 'post', data: params,})
}
export async function updateWechatMerchant(params) {
    return request({url: wechatMerchant, method: 'put', data: params,})
}
export async function deleteWechatMerchant(params) {
    return request({url: wechatMerchant, method: 'delete', data: params,})
}

export async function updateWechatCusPay(params) {
    return request({url: wechatCusPay, method: 'put', data: params,})
}

export async function findAlipayMerchants(params) {
    return request({url: alipayMerchants, method: 'get', data: params,})
}
export async function createAlipayMerchants(params) {
    return request({url: alipayMerchants, method: 'post', data: params,})
}
export async function updateAlipayMerchant(params) {
    return request({url: alipayMerchant, method: 'put', data: params,})
}
export async function deleteAlipayMerchant(params) {
    return request({url: alipayMerchant, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/payConfig.js